
	import { Prop, Vue } from 'vue-property-decorator';
	import { Observer } from 'mobx-vue';
	import Component from 'vue-class-component';
	import EditSVG from '@/components/EditSVG.vue';
	import { reaction } from 'mobx';

	@Observer
	@Component({
		components: {
			EditSVG
		}
	})
	export default class PrescriptionSummaryCategory extends Vue {
		@Prop({ required: true }) categoryTitle!: string;

		back(category: string = '') {
			this.$router.push('prescription#' + category.split(' ').join(''));
		}

		editEnabled() {
			return (
				this.$state.currentRoute !== '/order-styles' && this.$state.currentRoute !== '/saved-rx-list' && this.$state.currentRoute !== '/prescription'
			);
		}
	}
